import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ProductListingPage from './pages/ProductListingPage';
import ComparisonVariationsPage from './pages/ComparisonVariationsPage';
import CustomPage from './pages/CustomPage';
import AnimationVariationsPage from './pages/AnimationVariationsPage';
import PasswordProtection from './components/PasswordProtection';
export function App() {
  return <PasswordProtection data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/products/:category" element={<ProductListingPage data-id="element-6" />} data-id="element-5" />
          <Route path="/comparison-variations" element={<ComparisonVariationsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/custom" element={<CustomPage data-id="element-10" />} data-id="element-9" />
          <Route path="/animation-variations" element={<AnimationVariationsPage data-id="element-12" />} data-id="element-11" />
        </Routes>
      </BrowserRouter>
    </PasswordProtection>;
}